/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Bench_Reset_LabelInputs */

const en_home_bench_reset_label = /** @type {(inputs: Home_Bench_Reset_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reset example`)
};

const lv_home_bench_reset_label = /** @type {(inputs: Home_Bench_Reset_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Atiestatīt piemēru`)
};

/**
* | output |
* | --- |
* | "Reset example" |
*
* @param {Home_Bench_Reset_LabelInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const home_bench_reset_label = /** @type {((inputs?: Home_Bench_Reset_LabelInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Bench_Reset_LabelInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_home_bench_reset_label(inputs)
	return en_home_bench_reset_label(inputs)
});